// extracted by mini-css-extract-plugin
module.exports =  {"switchLabelFix":"switchLabelFix_BDuwALCn"};